import styled from 'styled-components';
import { CustomColors } from '../../styles/variables';

export const IEPlaceholder = styled.div`
    width: 100%;
    height: 100%;
    background: ${CustomColors.background};
`;

export const Wrapper = styled.div<{ useFullHeight?: boolean; navbarHeight?: string }>`
    height: ${({ useFullHeight, navbarHeight }) =>
        useFullHeight ? `100vh` : `calc(100vh - (1.75 * ${navbarHeight} + 28px))`};
    overflow: hidden;

    ${IEPlaceholder} {
        height: ${({ useFullHeight, navbarHeight }) =>
            useFullHeight ? `100vh` : `calc(100vh - (1.75 * ${navbarHeight} + 28px))`};
    }
`;
